"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = require("@react-google-maps/api");
var react_redux_1 = require("react-redux");
var use_query_params_1 = require("use-query-params");
var isNull_1 = __importDefault(require("lodash/isNull"));
var i18n_1 = __importDefault(require("../../i18n"));
var Filter_1 = __importDefault(require("../../features/searchParams/Filter"));
var react_i18next_1 = require("react-i18next");
var PlacesAutocomplete_1 = __importDefault(require("../../components/PlacesAutocomplete/PlacesAutocomplete"));
var SearchResult_1 = __importDefault(require("../../features/SearchResult/SearchResult"));
var GoogleGeocoding_1 = __importDefault(require("../../constants/GoogleGeocoding"));
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var wishListSlice_1 = require("../../features/wishList/wishListSlice");
var searchResultSlice_1 = require("../../features/SearchResult/searchResultSlice");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var globalSlice_1 = require("../../features/global/globalSlice");
var usePrevious_1 = require("../../hooks/usePrevious");
var RouterModal_1 = require("../../components/RouterModal");
var PostView_1 = require("../../components/PostView");
var Map_1 = __importDefault(require("./Map"));
var ResultsListConfig_1 = __importDefault(require("../../constants/ResultsListConfig"));
var filters_1 = require("../../helpers/filters");
var PageLoader_1 = __importDefault(require("../../components/PageLoader"));
var PostSort_1 = __importDefault(require("../../components/PostSort"));
var MobileActions_1 = __importDefault(require("./MobileActions"));
var Localization_1 = require("../../constants/Localization");
var useDeviceResize_1 = require("../../hooks/useDeviceResize");
var changeCSSStyles_1 = require("../../helpers/changeCSSStyles");
var objectHelper_1 = require("../../helpers/objectHelper");
var languageSlice_1 = require("../../features/languages/languageSlice");
var mapHelpers_1 = require("../../helpers/mapHelpers");
var PropertyTypes_1 = require("../../types/SearchPage/PropertyTypes");
var useInitSearchPagePrefix_1 = require("../../hooks/useInitSearchPagePrefix");
var StructureType_1 = require("../../types/SearchPage/StructureType");
var StateQueryTypes_1 = require("../../constants/SearchPageCategories/StateQueryTypes");
var useLocationPathName_1 = require("../../hooks/useLocationPathName");
var useSelectSearchPageAddress_1 = require("../../hooks/useSelectSearchPageAddress");
var roomField_1 = require("../../helpers/searchPageFiltering/roomField");
var developerField_1 = require("../../helpers/searchPageFiltering/developerField");
var propertyTypeField_1 = require("../../helpers/searchPageFiltering/propertyTypeField");
var structureTypeField_1 = require("../../helpers/searchPageFiltering/structureTypeField");
var DeveloperType_1 = require("../../types/SearchPage/DeveloperType");
var RoomCount_1 = require("../../constants/SearchPageCategories/RoomCount");
var RentalPriceType_1 = require("../../types/SearchPage/RentalPriceType");
var rentalPriceField_1 = require("../../helpers/searchPageFiltering/rentalPriceField");
var useSeoCleanLocationSubDirectoryPrefix_1 = require("../../hooks/useSeoCleanLocationSubDirectoryPrefix");
var SeoCleanURLTranslations_1 = require("../../constants/SearchPageCategories/SeoCleanURLTranslations");
var strings_1 = require("../../helpers/strings");
var classnames_1 = __importDefault(require("classnames"));
var SearchPage = function () {
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var t = react_i18next_1.useTranslation('common').t;
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var selectedDistrictsData = react_redux_1.useSelector(searchParamsSlice_1.useSelectSelectedDistrictsData);
    var filters = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var previousCurrency = usePrevious_1.usePrevious(currency);
    var previousLocation = usePrevious_1.usePrevious(location);
    var _a = react_1.useState(true), isMobilePostView = _a[0], setIsMobilePostView = _a[1];
    var _b = react_1.useState(true), isMobilePostViewIcon = _b[0], setIsMobilePostViewIcon = _b[1];
    var _c = react_1.useState(false), openMobileSort = _c[0], setOpenMobileSort = _c[1];
    var _d = react_1.useState(true), isMobileSortIcon = _d[0], setIsMobileSortIcon = _d[1];
    var _e = react_1.useState(), selectedState = _e[0], setSelectedState = _e[1];
    var _f = react_1.useState(false), isStateChosen = _f[0], setIsStateChosen = _f[1];
    var _g = use_query_params_1.useQueryParams({
        state: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        district: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
    }), stateQuery = _g[0], setStateQuery = _g[1];
    var _h = use_query_params_1.useQueryParams({
        renovation: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        structure_type: use_query_params_1.withDefault(use_query_params_1.StringParam, ''),
        developer_name: use_query_params_1.withDefault(use_query_params_1.StringParam, ''),
        rooms: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        rental_price_type: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        property_type: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        is_developer: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        sqm_price: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        price: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        monthly_mortgage: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        area: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        heating: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        furniture: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        amenities: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        bedrooms: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        floor: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        has_3D_tour: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        building_name: use_query_params_1.withDefault(use_query_params_1.StringParam, ''),
        animals: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        with_installment: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
        is_favorite: use_query_params_1.withDefault(use_query_params_1.ArrayParam, []),
    }), query = _h[0], setQuery = _h[1];
    var _j = react_1.useState([]), isDeveloperQuery = _j[0], setIsDeveloperQuery = _j[1];
    var _k = react_1.useState(), structureTypeQuery = _k[0], setStructureTypeQuery = _k[1];
    var _l = react_1.useState([]), roomsQuery = _l[0], setRoomsQuery = _l[1];
    var _m = react_1.useState([]), propertyTypeQuery = _m[0], setPropertyTypeQuery = _m[1];
    var _o = react_1.useState([]), rentalPrizeQuery = _o[0], setRentalPrizeQuery = _o[1];
    var _p = react_1.useState({
        state: [],
        district: [],
    }), hiddenStateQuery = _p[0], setHiddenStateQuery = _p[1];
    var _q = use_query_params_1.useQueryParams({
        public_code: use_query_params_1.withDefault(use_query_params_1.StringParam, ''),
    }), publicCode = _q[0], setPublicCode = _q[1];
    var _r = use_query_params_1.useQueryParams({
        address: use_query_params_1.withDefault(use_query_params_1.ObjectParam, {}),
        viewBox: use_query_params_1.withDefault(use_query_params_1.ObjectParam, GoogleGeocoding_1.default.MAP.VIEW_BOX),
        sortBy: use_query_params_1.withDefault(use_query_params_1.StringParam, ResultsListConfig_1.default.SORT_BY.DEFAULT),
        zoom: use_query_params_1.withDefault(use_query_params_1.NumberParam, GoogleGeocoding_1.default.MAP.ZOOM),
        page: use_query_params_1.withDefault(use_query_params_1.NumberParam, 1),
    }), additionalQuery = _r[0], setAdditionalQuery = _r[1];
    var _s = react_1.useState(false), isAddressPickerSelected = _s[0], setIsAddressPickerSelected = _s[1];
    var _t = react_1.useState(true), isSelectedMarker = _t[0], setIsSelectedMarker = _t[1];
    var _u = react_1.useState(false), isPostCardClicked = _u[0], setIsPostCardClicked = _u[1];
    var _v = react_1.useState(false), filterAreRemoved = _v[0], setFiltersAreRemoved = _v[1];
    var _w = react_1.useState(false), addressIsRemoved = _w[0], setAddressIsRemoved = _w[1];
    var _x = react_1.useState(false), isFetchGetDistrictByName = _x[0], setIsFetchGetDistrictByName = _x[1];
    var _y = react_1.useState(true), isChangedSeoCleanLocationSubDirectoryPrefix = _y[0], setIsChangedSeoCleanLocationSubDirectoryPrefix = _y[1];
    var _z = react_1.useState(''), seoCleanSlug = _z[0], setSeoCleanSlug = _z[1];
    var locationPathName = useLocationPathName_1.useLocationPathName(location);
    var previousStateQuery = usePrevious_1.usePrevious(stateQuery.state.length);
    var previousHiddenStateQuery = usePrevious_1.usePrevious(hiddenStateQuery.state.length);
    var previousLocationPathName = usePrevious_1.usePrevious(locationPathName);
    var address = useSelectSearchPageAddress_1.useSelectSearchPageAddress(location, isPostCardClicked);
    var deal = react_1.useMemo(function () { return Localization_1.PagePrefix[locationPathName]; }, [locationPathName]);
    var seoCleanLocationSubDirectoryPrefix = useSeoCleanLocationSubDirectoryPrefix_1.useSeoCleanLocationSubDirectoryPrefix(address, locationPathName, isChangedSeoCleanLocationSubDirectoryPrefix);
    var stateFilterIsSelected = react_1.useMemo(function () { return filters_1.hasAppliedFilters(stateQuery) || !!hiddenStateQuery.state.length; }, [stateQuery, hiddenStateQuery]);
    var memoizedHiddenStateQuery = react_1.useMemo(function () {
        return __assign(__assign(__assign({}, stateQuery), ((hiddenStateQuery === null || hiddenStateQuery === void 0 ? void 0 : hiddenStateQuery.state.length) && {
            state: hiddenStateQuery.state,
        })), ((hiddenStateQuery === null || hiddenStateQuery === void 0 ? void 0 : hiddenStateQuery.district.length) && {
            district: hiddenStateQuery.district,
        }));
    }, [hiddenStateQuery, stateQuery]);
    var memoizedQuery = react_1.useMemo(function () {
        return __assign(__assign(__assign(__assign(__assign(__assign({}, query), ((isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) && { is_developer: isDeveloperQuery })), ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) && {
            structure_type: structureTypeQuery,
        })), (propertyTypeQuery.length && {
            property_type: propertyTypeQuery,
        })), (roomsQuery.length && { rooms: roomsQuery })), ((rentalPrizeQuery === null || rentalPrizeQuery === void 0 ? void 0 : rentalPrizeQuery.length) && {
            rental_price_type: rentalPrizeQuery,
        }));
    }, [
        hiddenStateQuery,
        isDeveloperQuery,
        query,
        seoCleanLocationSubDirectoryPrefix,
        structureTypeQuery,
        propertyTypeQuery,
        roomsQuery,
        rentalPrizeQuery,
    ]);
    var filterIsSelected = react_1.useMemo(function () { return filters_1.hasAppliedFilters(memoizedQuery); }, [memoizedQuery]);
    useInitSearchPagePrefix_1.useInitSearchPagePrefix(filters, seoCleanLocationSubDirectoryPrefix, hiddenStateQuery, address, selectedDistrictsData, setHiddenStateQuery, isFetchGetDistrictByName, setIsFetchGetDistrictByName, setIsDeveloperQuery, currentLanguage, setPropertyTypeQuery, setStructureTypeQuery, setRoomsQuery, setRentalPrizeQuery, Localization_1.PagePrefix[locationPathName], isPostCardClicked, addressIsRemoved);
    react_1.useEffect(function () {
        removeSeoCleanQueryParams();
    }, [deal]);
    react_1.useEffect(function () {
        dispatch(searchParamsSlice_1.setSeoCleanLocationSubDirectoryPrefix(seoCleanLocationSubDirectoryPrefix));
    }, [seoCleanLocationSubDirectoryPrefix]);
    react_1.useEffect(function () {
        var _a;
        if (((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) &&
            previousStateQuery !== stateQuery.state.length) {
            dispatch(searchParamsSlice_1.getDistricts(__spreadArray([], stateQuery.state), true));
        }
        return function () {
            dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
            dispatch(searchParamsSlice_1.removeCustomPlace());
            dispatch(searchParamsSlice_1.clearSeoCleanLocationSubDirectoryPrefix());
        };
    }, []);
    react_1.useEffect(function () {
        if (hiddenStateQuery.state.length &&
            previousHiddenStateQuery !== hiddenStateQuery.state.length) {
            if (hiddenStateQuery.state.length === 1 &&
                selectedDistrictsData.length &&
                String(selectedDistrictsData[selectedDistrictsData.length - 1]
                    .parent_state_id) !== hiddenStateQuery.state[0] &&
                String(selectedDistrictsData[0].parent_state_id) !==
                    hiddenStateQuery.state[0]) {
                dispatch(searchParamsSlice_1.getDistricts(__spreadArray([], hiddenStateQuery.state), true));
            }
            if (hiddenStateQuery.state.length === 1 &&
                !selectedDistrictsData.length) {
                dispatch(searchParamsSlice_1.getDistricts(__spreadArray([], hiddenStateQuery.state), true));
            }
        }
    }, [hiddenStateQuery.state]);
    react_1.useEffect(function () {
        if (!(seoCleanLocationSubDirectoryPrefix === null || seoCleanLocationSubDirectoryPrefix === void 0 ? void 0 : seoCleanLocationSubDirectoryPrefix.length)) {
            setSeoCleanSlug('');
            setIsPostCardClicked(false);
        }
    }, [seoCleanLocationSubDirectoryPrefix]);
    // In case if current browser is Safari and device is mobile,
    // preventing background elements of map from scrolling
    react_1.useEffect(function () {
        changeCSSStyles_1.changeSearchPageBodyStyle(mobileResize, isMobilePostView);
    }, [isMobilePostView, mobileResize]);
    react_1.useEffect(function () {
        var _a;
        if (stateQuery.state.length &&
            previousStateQuery !== stateQuery.state.length) {
            dispatch(searchParamsSlice_1.setAppliedStates(stateQuery.state));
        }
        else if (hiddenStateQuery.state.length &&
            previousHiddenStateQuery !== hiddenStateQuery.state.length) {
            dispatch(searchParamsSlice_1.setAppliedStates(hiddenStateQuery.state));
        }
        else {
            dispatch(searchParamsSlice_1.setAppliedStates([]));
        }
        if (isStateChosen) {
            if ((_a = stateQuery.state) === null || _a === void 0 ? void 0 : _a.includes(String(selectedState))) {
                dispatch(searchParamsSlice_1.getDistricts(selectedState));
            }
            else {
                dispatch(searchParamsSlice_1.removeDistrictsByStateId({ id: selectedState }));
            }
        }
    }, [stateQuery.state, hiddenStateQuery.state, selectedState]);
    // If app currency is changed, we want to reset price filters
    react_1.useEffect(function () {
        if (previousCurrency && previousCurrency !== currency) {
            setQuery(function () {
                return {
                    price: undefined,
                    sqm_price: undefined,
                    monthly_mortgage: undefined,
                };
            });
        }
    }, [currency]);
    react_1.useEffect(function () {
        if (location.search.length) {
            sessionStorage.setItem('prevURL', "" + JSON.stringify(location));
        }
        if (location.pathname.split('/')[1] !==
            (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname.split('/')[1]) &&
            addressIsRemoved) {
            setAddressIsRemoved(false);
        }
        return function () {
            if (Localization_1.SPVPagePrefix["" + currentLanguage].includes(window.location.pathname.split('/')[3])) {
                return;
            }
            else {
                sessionStorage.removeItem('prevURL');
            }
        };
    }, [location]);
    var changeFilter = function (filterName, value, isStateChosen, isSingleChoose) {
        setIsChangedSeoCleanLocationSubDirectoryPrefix(!isChangedSeoCleanLocationSubDirectoryPrefix);
        if ((seoCleanLocationSubDirectoryPrefix === null || seoCleanLocationSubDirectoryPrefix === void 0 ? void 0 : seoCleanLocationSubDirectoryPrefix.length) &&
            location.pathname.search(seoCleanLocationSubDirectoryPrefix) >= 0 &&
            [
                StructureType_1.STRUCTURE_TYPE.FIELD_NAME,
                PropertyTypes_1.PROPERTY_TYPE.FIELD_NAME,
                RoomCount_1.ROOM_TYPE.FIELD_NAME,
                DeveloperType_1.DEVELOPER_TYPE.FIELD_NAME,
                RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.FIELD_NAME,
            ].includes(filterName)) {
            if (filterName === RoomCount_1.ROOM_TYPE.FIELD_NAME) {
                if (propertyTypeQuery[0] !== PropertyTypes_1.PROPERTY_TYPE.COMMERCIAL &&
                    !isDeveloperQuery.length &&
                    (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length)) {
                    roomField_1.makeRoomFieldFiltering(value, roomsQuery, currentLanguage, setRoomsQuery, structureTypeQuery, propertyTypeQuery, replacePageURL, deal, rentalPrizeQuery);
                }
                else {
                    replaceToQueryParams(isSingleChoose, filterName, value);
                }
            }
            if (filterName === DeveloperType_1.DEVELOPER_TYPE.FIELD_NAME) {
                if (value === DeveloperType_1.DEVELOPER_TYPE.True && !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length)) {
                    developerField_1.makeDeveloperFieldFiltering(value, isDeveloperQuery, setIsDeveloperQuery, propertyTypeQuery, roomsQuery, structureTypeQuery, replacePageURL, currentLanguage, deal);
                }
                else {
                    replaceToQueryParams(isSingleChoose, filterName, value);
                }
            }
            if (filterName === PropertyTypes_1.PROPERTY_TYPE.FIELD_NAME) {
                if (((roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
                    value === PropertyTypes_1.PROPERTY_TYPE.COMMERCIAL) ||
                    rentalPrizeQuery[0] ===
                        RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.RENTAL_PRIZE_TYPE ||
                    ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
                        !propertyTypeQuery.includes(value))) {
                    replaceToQueryParams(isSingleChoose, filterName, value);
                }
                else {
                    propertyTypeField_1.makePropertyTypeFieldFiltering(value, propertyTypeQuery, setPropertyTypeQuery, isDeveloperQuery, structureTypeQuery, roomsQuery, replacePageURL, currentLanguage, deal, rentalPrizeQuery, setIsDeveloperQuery, setStructureTypeQuery, setRoomsQuery);
                }
            }
            if (filterName === StructureType_1.STRUCTURE_TYPE.FIELD_NAME) {
                if (value !== StructureType_1.STRUCTURE_TYPE.NON_NEW_BUILDING &&
                    (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length)) {
                    structureTypeField_1.makeStructureTypeFieldFiltering(value, setStructureTypeQuery, isDeveloperQuery, propertyTypeQuery, replacePageURL, currentLanguage, deal, roomsQuery, rentalPrizeQuery);
                }
                else {
                    replaceToQueryParams(isSingleChoose, filterName, value);
                }
            }
            if (filterName === RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.FIELD_NAME) {
                if (!(isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
                    value === RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.RENTAL_PRIZE_TYPE &&
                    (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
                    propertyTypeQuery[0] !== PropertyTypes_1.PROPERTY_TYPE.COMMERCIAL) {
                    rentalPriceField_1.makeDailyPriceFieldFiltering(value, propertyTypeQuery, isDeveloperQuery, currentLanguage, roomsQuery, structureTypeQuery, rentalPrizeQuery, setRentalPrizeQuery, replacePageURL);
                }
                else {
                    replaceToQueryParams(isSingleChoose, filterName, value);
                }
            }
        }
        if (!(seoCleanLocationSubDirectoryPrefix === null || seoCleanLocationSubDirectoryPrefix === void 0 ? void 0 : seoCleanLocationSubDirectoryPrefix.length) ||
            ![
                StructureType_1.STRUCTURE_TYPE.FIELD_NAME,
                PropertyTypes_1.PROPERTY_TYPE.FIELD_NAME,
                RoomCount_1.ROOM_TYPE.FIELD_NAME,
                DeveloperType_1.DEVELOPER_TYPE.FIELD_NAME,
                RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.FIELD_NAME,
            ].includes(filterName)) {
            replaceToQueryParams(isSingleChoose, filterName, value);
        }
        setIsStateChosen(!!isStateChosen);
    };
    var replaceToQueryParams = function (isSingleChoose, filterName, value) {
        if (hiddenStateQuery.state.length || hiddenStateQuery.district.length) {
            history.replace('/' + locationPathName);
            setStateQuery(function () {
                var _a, _b;
                return (__assign(__assign({}, (((_a = hiddenStateQuery.state) === null || _a === void 0 ? void 0 : _a.length) && {
                    state: hiddenStateQuery.state,
                })), (((_b = hiddenStateQuery.district) === null || _b === void 0 ? void 0 : _b.length) && {
                    district: hiddenStateQuery.district,
                })));
            });
        }
        if (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) {
            setQueries(isSingleChoose, PropertyTypes_1.PROPERTY_TYPE.FIELD_NAME, propertyTypeQuery[0]);
        }
        if (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) {
            setQueries(isSingleChoose, StructureType_1.STRUCTURE_TYPE.FIELD_NAME, structureTypeQuery);
        }
        if (isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) {
            setQueries(isSingleChoose, DeveloperType_1.DEVELOPER_TYPE.FIELD_NAME, isDeveloperQuery[0]);
        }
        if (roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) {
            setQueries(isSingleChoose, RoomCount_1.ROOM_TYPE.FIELD_NAME, roomsQuery[0]);
        }
        if (rentalPrizeQuery === null || rentalPrizeQuery === void 0 ? void 0 : rentalPrizeQuery.length) {
            setQueries(isSingleChoose, RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.FIELD_NAME, rentalPrizeQuery[0]);
        }
        removeSeoCleanQueryParams();
        setQueries(isSingleChoose, filterName, value);
    };
    var removeSeoCleanQueryParams = react_1.useCallback(function () {
        setIsDeveloperQuery([]);
        setStructureTypeQuery(undefined);
        setPropertyTypeQuery([]);
        setHiddenStateInitialValues();
        setRentalPrizeQuery([]);
        setRoomsQuery([]);
    }, []);
    var setQueries = function (isSingleChoose, filterName, value) {
        setQuery(function (prevState) {
            var _a, _b;
            if (!isSingleChoose) {
                var filterValues = filters_1.handleQueryChange(prevState, filterName, value);
                return _a = {},
                    _a[filterName] = filterValues,
                    _a;
            }
            else {
                return _b = {},
                    _b[filterName] = value,
                    _b;
            }
        });
        setPublicCode({ public_code: undefined }, 'pushIn');
        setAdditionalQuery({
            address: undefined,
            page: 1,
        });
    };
    var replacePageURL = react_1.useCallback(function (subPath) {
        history.replace("/" + locationPathName + "/" + subPath + address);
    }, [locationPathName, address]);
    var paginatePosts = function (page) {
        setAdditionalQuery({ address: undefined, page: page });
        setIsPostCardClicked(false);
    };
    var handleSortChange = function (key) {
        setIsPostCardClicked(false);
        setQuery({ sortBy: key });
    };
    var onStateChange = function (state) {
        var filteredDistricts = filters_1.handleFilterStateDistricts(String(state), stateQuery, selectedDistrictsData);
        handleChangeStateDistrict('state', String(state), filteredDistricts);
        setIsStateChosen(true);
        setSelectedState(state);
        setIsPostCardClicked(false);
        setFiltersAreRemoved(false);
    };
    var onDistrictChange = function (district) {
        handleChangeStateDistrict('district', String(district));
    };
    var handleChangeStateDistrict = function (key, value, filteredDistricts) {
        var filterValues = filters_1.handleQueryChange(stateQuery, key, value);
        if (key === StateQueryTypes_1.StateQueryTypes.state) {
            handleStateQueryParamChange(filterValues, key, value, filteredDistricts);
        }
        else {
            handleDistrictQueryParamChange(filterValues, key, value);
        }
    };
    var handleStateQueryParamChange = function (filterValues, key, value, filteredDistricts) {
        if (location.pathname.search(seoCleanLocationSubDirectoryPrefix) ===
            0 &&
            filterValues.length === 1 &&
            !hiddenStateQuery.state.length) {
            history.replace("/" + locationPathName + "/" + SeoCleanURLTranslations_1.SeoCleanURLTranslations.realEstate[currentLanguage] +
                filters_1.concatAddressNameWithPrefix(filters_1.getStateName(filterValues[0], filters.state), currentLanguage));
            var stateFilteredData_1 = filters_1.getStateFilteredData(filters_1.getStateName(filterValues[0], filters.state), filters);
            stateFilteredData_1 &&
                setHiddenStateQuery(function () { return ({
                    district: [],
                    state: [String(stateFilteredData_1.govId)],
                }); });
        }
        else {
            if (location.pathname.search('state=') === -1 &&
                location.search.search('state=') === -1) {
                history.replace("/" + locationPathName);
                removeSeoCleanQueryParams();
            }
            setStateQuery(function (prevState) {
                var _a;
                var filterValues = filters_1.handleQueryChange(prevState, key, value);
                if (filterValues[0] === hiddenStateQuery.state[0]) {
                    return {
                        state: [],
                        district: filteredDistricts,
                    };
                }
                else {
                    return _a = {},
                        _a[key] = hiddenStateQuery.state.length
                            ? __spreadArray([hiddenStateQuery.state[0]], filterValues) : filterValues,
                        _a.district = filteredDistricts,
                        _a;
                }
            });
            setHiddenStateInitialValues();
        }
    };
    var handleDistrictQueryParamChange = function (filterValues, key, value) {
        if (seoCleanLocationSubDirectoryPrefix &&
            location.pathname.search(seoCleanLocationSubDirectoryPrefix) !==
                -1 &&
            filterValues.length === 1 &&
            !hiddenStateQuery.district.length) {
            var address_1 = filters_1.getDistrictName(filterValues[0], selectedDistrictsData, currentLanguage);
            history.replace("/" + locationPathName + "/" + seoCleanLocationSubDirectoryPrefix +
                address_1);
            var filteredData_1 = filters_1.getDistrictFilteredData(address_1[0], selectedDistrictsData);
            filteredData_1 &&
                setHiddenStateQuery(function (prevState) { return (__assign(__assign({}, prevState), { district: [String(filteredData_1.govId)] })); });
        }
        else {
            if (location.pathname.search('state=') === -1 &&
                location.search.search('state=') === -1) {
                history.replace("/" + locationPathName);
                removeSeoCleanQueryParams();
            }
            if (hiddenStateQuery.district.length) {
                setStateQuery(function (prevState) {
                    var filterValues = filters_1.handleQueryChange(prevState, key, value);
                    if (filterValues[0] === hiddenStateQuery.district[0]) {
                        return {
                            state: hiddenStateQuery.state,
                            district: [],
                        };
                    }
                    else {
                        return {
                            state: hiddenStateQuery.state,
                            district: [filterValues, hiddenStateQuery.district],
                        };
                    }
                });
                setHiddenStateInitialValues();
            }
            else {
                setStateQuery(function (prevState) {
                    var filterValues = filters_1.handleQueryChange(prevState, key, value);
                    return __assign(__assign({}, prevState), { district: filterValues });
                });
            }
            addQueryParams();
        }
        if (location.pathname.search(seoCleanLocationSubDirectoryPrefix) !==
            -1 &&
            location.pathname.search('um') === -1 &&
            filterValues.length === 1 &&
            hiddenStateQuery.district.length) {
            setStateQuery(function (prevState) {
                var filterValues = filters_1.handleQueryChange(prevState, key, value);
                return __assign(__assign({}, prevState), { district: filterValues });
            });
            addQueryParams();
        }
    };
    var setHiddenStateInitialValues = function () {
        setHiddenStateQuery({
            state: [],
            district: [],
        });
    };
    var addQueryParams = function () {
        setPublicCode({ public_code: undefined }, 'pushIn');
        setIsStateChosen(false);
        setAdditionalQuery(function (prevQuery) { return (__assign(__assign({}, prevQuery), { address: undefined, customViewBox: undefined, page: 1 })); });
    };
    var handleBuildingNameChange = function (value) {
        setQuery({ building_name: value }, 'pushIn');
    };
    var handlePublicCode = function (value) {
        if (value) {
            if (seoCleanLocationSubDirectoryPrefix === null || seoCleanLocationSubDirectoryPrefix === void 0 ? void 0 : seoCleanLocationSubDirectoryPrefix.length) {
                removeSeoCleanQueryParams();
                history.replace('/' + locationPathName);
            }
            dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
            setQuery(objectHelper_1.modifyObjectValues(query, undefined), 'pushIn');
            setPublicCode({ public_code: value }, 'pushIn');
            setStateQuery({ state: undefined, district: undefined }, 'pushIn');
        }
        else {
            setPublicCode({ public_code: undefined }, 'pushIn');
        }
    };
    var resetFilters = function () {
        history.replace("/" + Localization_1.SellPagePrefix[currentLanguage][deal]);
        dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
        removeSeoCleanQueryParams();
        setFiltersAreRemoved(true);
        setAddressIsRemoved(true);
    };
    var handleSaveSearchParams = react_1.useCallback(function () {
        dispatch(globalSlice_1.saveSearchParams(__assign(__assign(__assign(__assign({}, query), stateQuery), additionalQuery), { deal: locationPathName })));
        dispatch(globalSlice_1.addToastMessage({
            text: t('saved_successfully'),
            appearance: 'success',
        }));
    }, [query, stateQuery, additionalQuery, locationPathName]);
    var setMapQuery = react_1.useCallback(function (viewBox, zoom) {
        setIsAddressPickerSelected(false);
        if (!isPostCardClicked) {
            var queryData_1 = {
                viewBox: viewBox,
                page: 1,
            };
            if (zoom) {
                setAdditionalQuery(function () { return (__assign(__assign({}, queryData_1), { zoom: zoom })); }, 'pushIn');
            }
            else {
                setAdditionalQuery(function () { return (__assign({}, queryData_1)); }, 'pushIn');
            }
        }
    }, [isPostCardClicked]);
    var onAddBookmark = function (postId) {
        dispatch(wishListSlice_1.addBookmark(postId));
        dispatch(searchResultSlice_1.updateBookmark(postId, true));
    };
    var onRemoveBookmark = function (postId) {
        dispatch(wishListSlice_1.removeBookmark(postId));
        dispatch(searchResultSlice_1.updateBookmark(postId, false));
    };
    var closeSort = function () {
        setIsMobilePostView(true);
        setIsMobilePostViewIcon(true);
        setOpenMobileSort(false);
        setIsMobileSortIcon(true);
    };
    var handleAddressSelection = function (place) {
        var _a = place, geometry = _a.geometry, main_text = _a.main_text;
        setIsAddressPickerSelected(true);
        setStateQuery(function () { return ({
            state: undefined,
            district: undefined,
        }); }, 'pushIn');
        setAdditionalQuery({
            page: 1,
            viewBox: geometry,
            address: __assign(__assign({}, filters_1.extractStateDistrictFromPlace(place)), { placeName: mapHelpers_1.formatAddress(main_text) }),
        });
        setFiltersAreRemoved(false);
        setAddressIsRemoved(false);
    };
    var handleOpenPostPreviewBySlug = function (slug) {
        setIsPostCardClicked(true);
        if (seoCleanLocationSubDirectoryPrefix) {
            setSeoCleanSlug(slug);
            var prevURl = "/" + (locationPathName +
                '/' +
                seoCleanLocationSubDirectoryPrefix +
                address);
            if (additionalQuery.page && additionalQuery.page > 1) {
                prevURl += '?page=' + additionalQuery.page;
            }
            history.push('/' + strings_1.replaceSpaces(slug), {
                prevURL: prevURl,
            });
        }
        else {
            history.push('/' + slug, {
                prevURL: "/" + (locationPathName + location.search),
            });
        }
    };
    var handleClearAddress = function () {
        setStateQuery(function () { return ({
            state: ['1'],
        }); }, 'push');
        setAdditionalQuery({
            address: undefined,
            viewBox: undefined,
            page: 1,
        }, 'push');
        setAddressIsRemoved(true);
    };
    if (isNull_1.default(filters)) {
        return react_1.default.createElement(PageLoader_1.default, null);
    }
    return (react_1.default.createElement("div", { className: "search-page-main extend-ui" },
        react_1.default.createElement(Filter_1.default, { onSaveSearch: handleSaveSearchParams, changeFilter: changeFilter, filters: filters, handlePublicCode: handlePublicCode, appliedFilters: __assign(__assign(__assign(__assign({}, publicCode), memoizedQuery), memoizedHiddenStateQuery), { deal: Localization_1.PagePrefix[locationPathName] }), locationPathName: locationPathName, onStateChange: onStateChange, onDistrictChange: onDistrictChange, handleBuildingNameChange: handleBuildingNameChange, resetFilters: resetFilters }, isLoaded && (react_1.default.createElement(PlacesAutocomplete_1.default, { initialValue: additionalQuery.address.placeName, state: stateQuery.state, district: stateQuery.district, onClearAddress: handleClearAddress, onSelect: handleAddressSelection, addressIsRemoved: addressIsRemoved }))),
        react_1.default.createElement("div", { className: classnames_1.default('d-flex results-wrapper', {
                'mobile-is-post-view': isMobilePostView,
            }) },
            react_1.default.createElement("div", { className: "map-container" },
                isLoaded && (react_1.default.createElement(PlacesAutocomplete_1.default, { initialValue: additionalQuery.address.placeName, onSelect: handleAddressSelection, onClearAddress: handleClearAddress, state: stateQuery.state, district: stateQuery.district })),
                isLoaded && (react_1.default.createElement(Map_1.default, { state: filters.state.options, stateQuery: hiddenStateQuery.state.length
                        ? hiddenStateQuery
                        : stateQuery, additionalQuery: additionalQuery, public_code: publicCode.public_code, query: memoizedQuery, locationPathName: locationPathName, stateFilterIsSelected: stateFilterIsSelected, filterAreRemoved: filterAreRemoved, isAddressPickerSelected: isAddressPickerSelected, onStateChange: onStateChange, setIsSelectedMarker: setIsSelectedMarker, handleOpenPostPreviewBySlug: handleOpenPostPreviewBySlug, onAddBookmark: onAddBookmark, onRemoveBookmark: onRemoveBookmark, setMapQuery: setMapQuery, isPostCardClicked: isPostCardClicked }))),
            react_1.default.createElement(SearchResult_1.default, { handleSortChange: handleSortChange, filters: filters, onAddBookmark: onAddBookmark, onRemoveBookmark: onRemoveBookmark, resetFilters: resetFilters, paginatePosts: paginatePosts, handleOpenPostPreviewBySlug: handleOpenPostPreviewBySlug, filterIsSelected: filterIsSelected, stateFilterIsSelected: stateFilterIsSelected, isPostCardClicked: isPostCardClicked, query: memoizedQuery, public_code: publicCode.public_code, additionalQuery: additionalQuery, stateQuery: memoizedHiddenStateQuery, locationPathName: locationPathName, seoCleanLocationSubDirectoryPrefix: seoCleanLocationSubDirectoryPrefix, previousLocationPathName: previousLocationPathName })),
        openMobileSort && (react_1.default.createElement("div", { className: "results-wrapper mobile-sort" },
            react_1.default.createElement(PostSort_1.default, { handleSortChange: handleSortChange, close: closeSort, selected: query.sortBy || 'date_desc' }))),
        !isSelectedMarker && (react_1.default.createElement("div", { className: "search-page-actions" },
            react_1.default.createElement(MobileActions_1.default, { isMobilePostViewIcon: isMobilePostViewIcon, isMobileSortIcon: isMobileSortIcon, setIsMobilePostView: setIsMobilePostView, setIsMobilePostViewIcon: setIsMobilePostViewIcon, setOpenMobileSort: setOpenMobileSort, setIsMobileSortIcon: setIsMobileSortIcon }))),
        react_1.default.createElement(react_router_dom_1.Route, { path: !seoCleanLocationSubDirectoryPrefix
                ? "/" + locationPathName + "/:slug"
                : "/" + locationPathName + "/:" + seoCleanSlug, render: function (modalRouterProps) {
                return (react_1.default.createElement(RouterModal_1.RouterModal, { backUrl: "/" + locationPathName, setIsPostCardClicked: setIsPostCardClicked },
                    react_1.default.createElement(PostView_1.PostView, { slug: modalRouterProps.location.pathname.substring(1), isPreview: false })));
            } })));
};
exports.default = SearchPage;
